export default {
    getConfig: state => state.config,
    getTags: state => state.tags,
}
  